import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import globalStyle from "./../../globalStyle";

const CustomSelect = ({
  icon,
  children,
  placeholder,
  disabled,
  formStyleProps = {},
  ...props
}) => {
  return (
    <FormControl
      fullWidth
      disabled={disabled}
      sx={{ ...formStyleProps, ...globalStyle.customSelect }}
    >
      <InputLabel>{placeholder}</InputLabel>
      <Select
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        {...props}
        label={placeholder}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
